import { lazy } from "react";
import NotFound from "../../components/ui/page/NotFound";
const Products = lazy(() => import("../../pages/Admin/Products"));
const Categories = lazy(() => import("../../pages/Admin/Categories"));
const Dashboard = lazy(() => import("../../pages/Admin/Dashboard"));

const controlPanel = [
  {
    path: "products/*",
    component: Products,
  },
  {
    path: "categories/*",
    component: Categories,
  },

  {
    path: "",
    component: Dashboard,
  },

  {
    path: "dashboard/*",
    component: Dashboard,
  },

  {
    path: "*",
    component: NotFound,
  },
];

export default controlPanel;
